import { Link } from "react-router-dom";
import { MaskLine, Reveal, ClipImage } from "../components/Motion";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { fileUrl } from "../lib/api";

const SHOWROOM = "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
const DETAIL = "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const STATS_DEFAULT = [
  { n: "80 jaar", l: "Gevestigd in Vinkeveen" },
  { n: "33 jaar", l: "Erkend Ford-dealer" },
  { n: "AVIA", l: "Bediend tankstation" },
];

export default function Over() {
  const { get } = useContent();
  const stats = get("over.stats", STATS_DEFAULT);
  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-primary mb-4">{get("over.eyebrow", "Over ons")}</p>
        <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-[0.9] text-text-main max-w-4xl">
          <MaskLine>{get("over.title1", "Het vertrouwde")}</MaskLine>
          <MaskLine delay={0.12}>{get("over.title2", "autobedrijf van")}</MaskLine>
          <MaskLine delay={0.24}><span className="text-primary">{get("over.title3", "Vinkeveen")}</span></MaskLine>
        </h1>

        <div className="mt-16 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="space-y-6 text-lg text-text-muted leading-relaxed max-w-xl">
              <p>{get("over.p1", "Automobielbedrijf Stoof is al ruim 80 jaar gevestigd in Vinkeveen en meer dan 33 jaar erkend Ford-(service)dealer. Een klein bedrijf met grote kwaliteiten, waar de klant nog koning is.")}</p>
              <p>{get("over.p2", "Klantvriendelijkheid en goede service staan bij ons voorop. We werken met korte lijnen en persoonlijke aandacht voor iedere klant en elke Ford. Naast ons erkend reparateurschap hebben we ook een bediend AVIA-tankstation op locatie.")}</p>
              <p>{get("over.p3", "Kom gerust eens langs aan de Herenweg in Vinkeveen. De koffie staat klaar.")}</p>
            </div>
          </Reveal>
          <ClipImage src={fileUrl(get("afbeeldingen.over_showroom", SHOWROOM))} alt="Onze showroom" className="aspect-[4/3]" />
        </div>

        <div className="mt-24 grid sm:grid-cols-3 gap-px bg-border border border-border">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.08} className="bg-background p-10">
              <p className="font-display font-black text-5xl text-primary">{s.n}</p>
              <p className="text-text-muted mt-2">{s.l}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-24 grid lg:grid-cols-2 gap-12 items-center">
          <ClipImage src={fileUrl(get("afbeeldingen.over_detail", DETAIL))} alt="Detail werkplaats" className="aspect-[4/3] order-2 lg:order-1" />
          <Reveal className="order-1 lg:order-2">
            <h2 className="font-display font-bold text-3xl sm:text-4xl tracking-tight">{get("over.block2_title", "Onderhoud & schadeherstel in eigen huis")}</h2>
            <p className="mt-6 text-lg text-text-muted leading-relaxed max-w-xl">
              {get("over.block2_text", "Onze deskundige monteurs verzorgen onderhoud, APK en reparaties met de modernste apparatuur. Als erkend schadegarant reparateur herstellen we ook schade snel en vakkundig — zo blijft uw Ford ook ná aankoop in vertrouwde handen.")}
            </p>
            <Link to="/contact" className="mt-8 group inline-flex items-center gap-2 rounded-full bg-primary text-white font-semibold px-7 py-4 hover:bg-primary-light transition-colors">
              {get("over.block2_btn", "Maak een afspraak")}
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
